import { format } from 'date-fns';
import { enUS } from 'date-fns/locale';
import i18next from 'i18next';

export function formatDate(date, fmt = 'MM/dd/y', locale = enUS) {
  const dt = new Date(date);
  return format(dt, fmt, { locale });
}

export function formatDateTime(date) {
  const dt = new Date(date);
  return format(dt, 'MM/dd/y hh:mm aa');
}

export function formatDateTimeTimeline(date) {
  const dt = new Date(date);
  return format(dt, 'd MMM yyyy · hh:mm aa');
}

function toSfhNaiveDate(date) {
  const naive =
    typeof date === 'string'
      ? date.replace(/(\.\d+)?(Z|[+-]\d{2}:?\d{2})$/, '')
      : date;
  return new Date(naive);
}

export function formatSfhTimelineDate(date) {
  if (!date) return '';
  return format(toSfhNaiveDate(date), 'd MMM yyyy · hh:mm aa');
}

export function formatSfhDate(date) {
  if (!date) return '';
  return format(toSfhNaiveDate(date), 'd MMM yyyy');
}

export function formatSfhDateTime(date) {
  if (!date) return '';
  return format(toSfhNaiveDate(date), 'MM/dd/yyyy hh:mm aa');
}

export function getDateDay(date) {
  const dt = new Date(date);
  return format(dt, 'dd');
}

export function getDateMonth(date) {
  const dt = new Date(date);
  return format(dt, 'MM');
}

export function getDateYear(date) {
  const dt = new Date(date);
  return format(dt, 'y');
}

export function formatDateTimeLocale(date) {
  const dt = new Date(date);
  return format(dt, 'MM/dd/y hh:mm aa');
}

// TODO add locale
export function formatDateRange(dates) {
  const start = formatDate(dates.start);
  const end = formatDate(dates.end);
  return i18next.t('common.date.range', { start, end });
}

export function getDate() {
  const date = new Date();
  return { date };
}
